import { withLatestFrom, filter, map } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { NodeAction } from '@cbridge-packages/node';
import { IGetSelectorStateType } from '@cbridge-utils/reselect';
import { StreamsFilterAction } from '../streamsFilter.action';
import { selectedStreamIdSelector } from '../_selectors/selectedStreamId.selector';

type IState =
  & IGetSelectorStateType<typeof selectedStreamIdSelector>;

export const clearStreamOnNodeSelectEpic: IEpic<IState> = (action$, state$) => action$.pipe(
  isTypeOfAndGetPayload(NodeAction.toggleSelect),
  withLatestFrom(state$),
  filter(([, state]) => Boolean(selectedStreamIdSelector(state))),
  map(() => StreamsFilterAction.clearSelect()),
);
